<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableSecurityGroupListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../dynamoDB/TableExpand.vue";
var tableSecurityGroupVue = {};
export default {
  name: "TableDynamoDB",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      val: "",
      columns: [
        {
          type: "expand",
          width: 50,
          render: (h, params) => {
            return h(TableExpand, {
              props: {
                row: params.row
              }
            });
          }
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("permission_configuration_management.account.accountId"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region"
        },
        {
          title: this.$t('Bill.CostAllocation.name'),
          key: "tableName"
        },
        {
          title: this.$t("alarms.common.status"),
          key: "tableStatusName"
        },
        {
          title: this.$t("RAM.AWS.DynamoDB.partitionKey"),
          key: "partitionKey"
        },
        {
          title: this.$t("RAM.AWS.DynamoDB.sortKey"),
          key: "sortKey"
        },
        {
          title: this.$t("RAM.AWS.DynamoDB.index"),
          key: "itemCount"
        },
        // {
        //   title: this.$t("RAM.AWS.DynamoDB.deleteProtection"),
        //   key: 'deleteProtection'
        // },
        {
          title: this.$t("RAM.AWS.DynamoDB.readCapacityMode"),
          key: 'readCapacityUnits'
        },
        {
          title: this.$t("RAM.AWS.DynamoDB.writeCapacityMode"),
          key: 'writeCapacityUnits'
        },
        {
          title: this.$t("RAM.AWS.DynamoDB.totalSize"),
          key: 'tableSizeBytes'
        },
        {
          title: this.$t("RAM.AWS.DynamoDB.listClass"),
          key: 'tableClassName'
        }
      ],
      tableSecurityGroupListData: []
    };
  },
  beforeCreate: function() {
    tableSecurityGroupVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountName", function(val) {
      tableSecurityGroupVue.accountName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableSecurityGroupVue.companyId = val;
    });
    eventBus.$on("tableName", function(val) {
      tableSecurityGroupVue.tableName = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    // 分页显示数据
    /****************************************************/
    getSecurityGroupListData: function() {
      var pageSecurityGroupDate = {
        pageNum: this.current,
        pageSize: this.pageSize,
        accountName: tableSecurityGroupVue.accountName,
        companyId: tableSecurityGroupVue.companyId,
        tableName: tableSecurityGroupVue.tableName
      };
      this.$api.cmdb
        .pagingQueryDynamoDB(pageSecurityGroupDate)
        .then(res => {
          this.tableSecurityGroupListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableSecurityGroupVue.getSecurityGroupListData();
    },
    // 销毁
    beforeDestroy: function() {
      eventBus.$off("accountName");
      eventBus.$off("companyId");
      eventBus.$off("tableName");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/dynamoDB/TableDynamoDB.vue